module.exports = __webpack_public_path__ + "static/dev-03692a6f95f72aa70a6d2694c55ef60a.jpg";